import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Track from "./pages/Track";
import Login from "./pages/Login";
import Scan from "./pages/Scan";
import Label from "./pages/Label";
import Contact from "./pages/Contact";
import Help from "./pages/Help";

import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Shipments from "./pages/admin/Shipments";
import NewShipment from "./pages/admin/NewShipment";
import Roles from "./pages/admin/Roles";
import Users from "./pages/admin/Users";
import Audit from "./pages/admin/Audit";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Home />} />
              <Route path="/track/:id" element={<Track />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/help" element={<Help />} />
              <Route path="/login" element={<Login />} />

              {/* Auth-required */}
              <Route path="/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
              <Route path="/label/:id" element={<ProtectedRoute requirePerm="can_reprint_labels"><Label /></ProtectedRoute>} />

              {/* Admin */}
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="shipments" element={<Shipments />} />
                <Route path="shipments/new" element={<ProtectedRoute requirePerm="can_create_shipments"><NewShipment /></ProtectedRoute>} />
                <Route path="roles" element={<ProtectedRoute requirePerm="can_manage_roles"><Roles /></ProtectedRoute>} />
                <Route path="users" element={<ProtectedRoute requirePerm="can_manage_users"><Users /></ProtectedRoute>} />
                <Route path="audit" element={<ProtectedRoute requirePerm="can_view_audit_log"><Audit /></ProtectedRoute>} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0F1D14",
            color: "#F5EFE0",
            border: "1px solid #D4AF37",
            borderRadius: "2px",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
